<template>
  <modal title="" width="45" class="sm:62" :showModal="showModal" @close-modal="closeModal">

    <div class="picture-upload-form text-center">
      <div class="my-3">
        <image-uploader @input="handleImageUpload($event)" @remove-image="removeImage"
          :isUploadingImage="isUploadingImage" />
      </div>
    </div>
    <form @submit.prevent="createUser">
        <div class="new-user-form__single-input-wrapper">
          <label for="fname" class="label">First Name</label>
          <input type="text" class="input" v-model="newUser.fname" placeholder="-- Enter First Name --" />
        </div>
        <div class="new-user-form__single-input-wrapper">
          <label for="lname" class="label">Last Name</label>
          <input type="text" class="input" v-model="newUser.lname" placeholder="-- Enter Last Name --" />
        </div>
        <div class="new-user-form__single-input-wrapper">
          <label for="gender" class="label">Gender</label>
          <el-select v-model="newUser.gender" placeholder="-- Select --">
            <el-option v-for="gender in genders" :key="gender" :label="gender" :value="gender">
            </el-option>
          </el-select>
        </div>
        <div class="new-user-form__single-input-wrapper">
          <label for="email" class="label">Work Email</label>
          <input type="email" class="input" v-model="newUser.email" />
          <div v-if="apiError" class="p-3 bg-red-100 text-red-600">
              {{ apiErrorMsg }}
          </div>
        </div>
        <div class="new-user-form__single-input-wrapper">
          <label for="number" class="label">Phone Number</label>
          <vue-tel-input v-model="newUser.phoneNo"></vue-tel-input>
        </div>

        <div class="new-user-form__single-input-wrapper mt-2">
          <label for="employment-type" class="label">Employment Type</label>
          <el-select v-model="newUser.employmentType" placeholder="">
            <el-option v-for="employmentType in employmentTypes" :key="employmentType" :label="employmentType"
              :value="employmentType">
            </el-option>
          </el-select>
        </div>
        <div class="flex items-center justify-between">
          <div class="cursor-pointer" @click="$router.go(-1)">
            <p>Cancel</p>
          </div>
          <base-button text="Add User" :disabled="disableButton" type="submit" :loading="creatingUser" />
        </div>
    </form>
    
  </modal>
</template>

<script>
import ImageUploader from "@/components/3pl/Users/ImageUploader";
export default {
  components: {
    ImageUploader,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      newUser: {
        fname: "",
        // mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
        // imageurl: "",
      },
      genders: ["Male", "Female"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      creatingUser: false,
      roles: [],
      selectedRoleId: null,
      isUploadingImage: false,
      apiError : false,
      apiErrorMsg : ""
    };
  },
  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },
  },
  mounted() {
    let roles = localStorage.getItem("roles");
    if (roles) {
      this.roles = roles;
    } else {
      this.getRoles();
    }
  },
  methods: {
    async createUser() {
      this.creatingUser = true;

      try {
        const role = {
          appSlug: "muleex",
          roleId: this.selectedRoleId,
        };

        await this.$_createUser({ ...this.newUser, role: role });
        this.onCreateUser();
      } catch (error) {
        this.apiError = true
        this.apiErrorMsg = error.response.data.message
        this.handleError(error);
        this.creatingUser = false;
      }
    },
    async getRoles() {
      try {
        let response = await this.$_getRoles();
        this.roles = response.data.roles;
      } catch (error) {
        this.handleError(error);
      }
    },
    onCreateUser() {
      this.creatingUser = false;
      this.generateToast("User has successfully been created", "success");
      this.resetUser();
      this.$store.dispatch("resetUserList");
      this.$emit("close-modal");
      this.$emit("refetch-user")

    },
    resetUser() {
      this.newUser = {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
        roles: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newUser.imageurl = response;
        // console.log("imageurl", response);
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newUser.imageurl = null;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
